import type {
  RouteLocationNormalized,
  RouteLocationRaw,
} from 'vue-router';
import { useRemoteConfigStore } from '@/shared/firebase';
import { resolveRouteFeatureFlagAllowed } from '@/shared/firebase/utils/resolveRouteFeatureFlagAllowed.util';
import { isRfqMultiTransactionFlow } from '@/modules/multiTransactionV2/utils/rfqFlow.util';

const MULTI_TRANSACTION_ROUTE_NAMES = new Set([
  'multi-transaction',
  'multi-transaction-index',
]);

function isMultiTransactionRoute(to: RouteLocationNormalized): boolean {
  if (MULTI_TRANSACTION_ROUTE_NAMES.has(String(to.name ?? ''))) {
    return true;
  }

  return to.path.startsWith('/multi-transaction');
}

/**
 * Bloquea el multienvío RFQ (`?flow=rfq`) cuando `feature_rfq_extended` está deshabilitado.
 */
export function validateRfqMultiTransactionFeatureFlag(
  to: RouteLocationNormalized,
  _from: RouteLocationNormalized
): boolean | RouteLocationRaw {
  if (!isMultiTransactionRoute(to) || !isRfqMultiTransactionFlow(to.query)) {
    return true;
  }

  const remoteConfigStore = useRemoteConfigStore();
  const isExtendedEnabled = resolveRouteFeatureFlagAllowed(
    remoteConfigStore,
    'feature_rfq_extended'
  );

  if (!isExtendedEnabled) {
    return { name: 'movements' };
  }

  return true;
}
